import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_78_63)">
        <path d="M13.9632 0C17.2668 0 18.6037 0.371302 19.9074 1.06853C21.2111 1.76576 22.2342 2.78891 22.9315 4.09262C23.6287 5.39632 24 6.73321 24 10.0368V13.9632C24 17.2668 23.6287 18.6037 22.9315 19.9074C22.2342 21.2111 21.2111 22.2342 19.9074 22.9315C18.6037 23.6287 17.2668 24 13.9632 24H10.0368C6.73321 24 5.39632 23.6287 4.09262 22.9315C2.78891 22.2342 1.76576 21.2111 1.06853 19.9074C0.371302 18.6037 0 17.2668 0 13.9632L0 10.0368C0 6.73321 0.371302 5.39632 1.06853 4.09262C1.76576 2.78891 2.78891 1.76576 4.09262 1.06853C5.39632 0.371302 6.73321 0 10.0368 0L13.9632 0ZM13.4142 15.6569C12.6332 14.8758 11.3668 14.8758 10.5858 15.6569L12 17.0711L13.4142 15.6569ZM16.2426 12.8284C13.8995 10.4853 10.1005 10.4853 7.75736 12.8284L9.17157 14.2426C10.7337 12.6805 13.2663 12.6805 14.8284 14.2426L16.2426 12.8284ZM19.0711 10C15.1658 6.09476 8.83418 6.09476 4.92893 10L6.34315 11.4142C9.46734 8.29002 14.5327 8.29002 17.6569 11.4142L19.0711 10Z" />
      </g>
      <defs>
        <clipPath id="clip0_78_63">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
